
(function () {
  "use strict";

  var CONFIG = {
    storeKey: "ovr_attr_v2",
    sessionKey: "ovr_attr_sess",
    sentKey: "ovr_attr_sent",

    sessionTimeoutMinutes: 30,
    debounceMs: 300,

    // Click-id params matched by shape: gclid, gbraid, wbraid, fbclid, ttclid,
    // msclkid, rdt_cid, sccid, epik, irclickid, li_fat_id, and future lookalikes.
    clickIdPattern: /(?:clid|clkid|ckid|ccid|braid|_cid|click_id|epik|fat_id)$/i,

    hasConsent: function () { return true; },
    debug: false
  };

  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id"];

  function log() {
    if (CONFIG.debug && window.console) console.log.apply(console, ["[attr]"].concat([].slice.call(arguments)));
  }
  function now() { return Date.now(); }
  function daysBetween(a, b) { return Math.floor(Math.abs(a - b) / 86400000); }

  /* ---------- storage (degrades to in-memory if localStorage is unavailable) - */

  var mem = {};
  function read(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return mem[key] || fallback;
      var parsed = JSON.parse(raw);
      return (parsed && typeof parsed === "object") ? parsed : fallback;
    } catch (e) {
      return mem[key] || fallback;
    }
  }
  function write(key, value) {
    if (!CONFIG.hasConsent()) return;
    mem[key] = value; // fallback-of-the-fallback: current pageview always works
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  /* ---------- normalisation ------------------------------------------------- */

  function normPath(p) {
    try { p = decodeURIComponent(p || "/"); } catch (e) { p = p || "/"; }
    p = p.split("?")[0].split("#")[0].toLowerCase().trim();
    if (p.length > 1) p = p.replace(/\/+$/, "");
    return p || "/";
  }
  function normValue(v) {
    return String(v == null ? "" : v).toLowerCase().trim().slice(0, 255);
  }
  function cartCookie() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
      return m ? m[1].slice(0, 64) : "";
    } catch (e) { return ""; }
  }

  /* ---------- touch construction --------------------------------------------- */

  // Built from the CURRENT url only, never merged with the previous touch —
  // no Frankenstein rows (klaviyo source + Meta ad IDs in content/term).
  function buildTouch(params, referrer) {
    var touch = { ts: now() };
    var found = false;

    for (var i = 0; i < UTM_KEYS.length; i++) {
      var v = params.get(UTM_KEYS[i]);
      if (v) { touch[UTM_KEYS[i]] = normValue(v); found = true; }
    }

    try {
      params.forEach(function (value, key) {
        if (touch.click_id || !value) return;
        if (CONFIG.clickIdPattern.test(key)) {
          touch.click_param = key.toLowerCase().slice(0, 40);
          touch.click_id = String(value).trim().slice(0, 255);
          found = true;
        }
      });
    } catch (e) {}

    if (found) return touch;

    // Untagged: record the raw external referrer host; reporting classifies it.
    var host = "";
    try { host = referrer ? new URL(referrer).hostname.toLowerCase() : ""; } catch (e) {}
    if (!host || host === window.location.hostname) return null;
    touch.referrer_host = host.slice(0, 120);
    return touch;
  }

  /* ---------- state machine --------------------------------------------------- */

  var params;
  try { params = new URL(window.location.href).searchParams; }
  catch (e) { params = new URLSearchParams(""); }

  var path = normPath(window.location.pathname);
  var state = read(CONFIG.storeKey, {});
  var session = read(CONFIG.sessionKey, {});
  var t = now();

  var isNewSession = !session.ts || (t - session.ts) > CONFIG.sessionTimeoutMinutes * 60000;
  if (isNewSession) session = { ts: t, landing: path };
  session.ts = t;
  write(CONFIG.sessionKey, session);

  // First touch: written once, never modified.
  if (!state.first) {
    state.first = buildTouch(params, document.referrer) || { ts: t };
    state.first.landing_page = path;
  }

  // Last touch: last NON-DIRECT click, atomic replace, never deleted.
  // Hierarchy: tagged (utm / click id) always wins; bare external referrer only
  // fills a gap or replaces another bare referrer. Direct visits change nothing.
  var incoming = buildTouch(params, isNewSession ? document.referrer : "");
  if (incoming) {
    var incomingTagged = !!(incoming.utm_source || incoming.utm_medium || incoming.utm_campaign || incoming.click_id);
    var storedTagged = !!(state.last && (state.last.utm_source || state.last.utm_medium || state.last.utm_campaign || state.last.click_id));
    if (incomingTagged || !storedTagged) {
      state.last = incoming;               // whole object swapped, no key merging
      log("last touch replaced", incoming);
    }
  }

  state.last_page_path = path;
  state.v = 2;
  write(CONFIG.storeKey, state);

  /* ---------- cart attributes -------------------------------------------------- */

  function buildAttributes() {
    var last = state.last || {};
    var first = state.first || {};

    return {
      attr_v: "2",

      // LAST TOUCH — never expires; filter on attr_age_days in reporting
      utm_source: last.utm_source || "",
      utm_medium: last.utm_medium || "",
      utm_campaign: last.utm_campaign || "",
      utm_content: last.utm_content || "",
      utm_term: last.utm_term || "",
      utm_id: last.utm_id || "",
      attr_click_param: last.click_param || "",
      attr_click_id: last.click_id || "",
      attr_referrer_host: last.referrer_host || "",
      attr_age_days: last.ts ? String(daysBetween(now(), last.ts)) : "",

      // FIRST TOUCH — evergreen, explicitly labelled
      ft_utm_source: first.utm_source || "",
      ft_utm_medium: first.utm_medium || "",
      ft_utm_campaign: first.utm_campaign || "",

      // PAGES
      landing_page_path: first.landing_page || "",   // first ever (v1 continuity)
      session_landing_path: session.landing || "",   // this session's entry page
      last_page_path: state.last_page_path || ""
    };
  }

  function post(attributes, urgent) {
    var body = JSON.stringify({ attributes: attributes });
    var opts = { method: "POST", headers: { "Content-Type": "application/json" }, body: body };
    if (urgent) opts.keepalive = true;     // survives navigation away

    try {
      return window.fetch("/cart/update.js", opts).catch(function (e) { log("post failed", e); });
    } catch (e) {
      if (urgent) {
        try { navigator.sendBeacon("/cart/update.js", new Blob([body], { type: "application/json" })); }
        catch (e2) {}
      }
    }
  }

  // Dedupe is keyed on attributes + CART TOKEN. When the cart resets after a
  // purchase, the token changes and the next pageview re-attributes the new
  // cart — this is what guarantees "every order", including repeat orders in
  // the same session. (v2.1 would have silently skipped the second cart.)
  var timer = null;
  function push(urgent) {
    if (!CONFIG.hasConsent()) return;
    var attributes = buildAttributes();
    var sig = cartCookie() + "|" + JSON.stringify(attributes);

    if (!urgent) {
      try { if (window.sessionStorage.getItem(CONFIG.sentKey) === sig) return; } catch (e) {}
    }

    var fire = function () {
      try { window.sessionStorage.setItem(CONFIG.sentKey, sig); } catch (e) {}
      log("push", attributes);
      post(attributes, urgent);
    };

    if (timer) { clearTimeout(timer); timer = null; }
    if (urgent) { fire(); return; }
    timer = setTimeout(fire, CONFIG.debounceMs);
  }

  push();

  /* ---------- guaranteed-delivery flushes ---------------------------------------
   * A fallback system fails exactly at the exits, so flush at every exit:
   *  - click on any checkout control (incl. express/dynamic checkout buttons)
   *  - submit of any form targeting /checkout or /cart (covers Enter key)
   *  - pagehide (covers Shop Pay redirects, external payment sheets, tab close,
   *    and anything the selectors miss)
   * ---------------------------------------------------------------------------- */

  var CHECKOUT_SEL = [
    'a[href*="/checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[data-checkout]',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    '[data-shopify="payment-button"]',
    '.shopify-payment-button',
    '.additional-checkout-buttons'
  ].join(", ");

  document.addEventListener("click", function (event) {
    try {
      var el = event.target && event.target.closest ? event.target.closest(CHECKOUT_SEL) : null;
      if (el) push(true);
    } catch (e) {}
  }, true);

  document.addEventListener("submit", function (event) {
    try {
      var f = event.target;
      var action = (f && f.getAttribute && (f.getAttribute("action") || "")) || "";
      if (/\/checkout|\/cart/.test(action)) push(true);
    } catch (e) {}
  }, true);

  window.addEventListener("pagehide", function () {
    try {
      if (timer) push(true);   // flush any pending debounced write before leaving
    } catch (e) {}
  });

  /* ---------- add-to-cart interception -------------------------------------------
   * If the very first cart interaction is an add-to-cart (cart created by
   * /cart/add.js, not by our pageload update), re-push immediately after so the
   * newborn cart is attributed before any express checkout can fire.
   * ---------------------------------------------------------------------------- */

  (function () {
    var origFetch = window.fetch;
    if (typeof origFetch !== "function") return;
    window.fetch = function (input, init) {
      var url = "";
      try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function () { push(true); }).catch(function () {});
      }
      return p;
    };
  })();

  /* ---------- SPA / Replo route changes ------------------------------------------ */

  (function () {
    function onRoute() {
      try {
        var p = normPath(window.location.pathname);
        if (p === path) return;
        path = p;
        state.last_page_path = p;
        write(CONFIG.storeKey, state);
        push();
      } catch (e) {}
    }
    ["pushState", "replaceState"].forEach(function (m) {
      var orig = history[m];
      if (typeof orig !== "function") return;
      history[m] = function () { var r = orig.apply(this, arguments); onRoute(); return r; };
    });
    window.addEventListener("popstate", onRoute);
  })();

  /* ---------- debug handle --------------------------------------------------------- */

  window.OvrAttribution = {
    state: function () { return read(CONFIG.storeKey, {}); },
    session: function () { return read(CONFIG.sessionKey, {}); },
    attributes: buildAttributes,
    resync: function () { push(true); },
    reset: function () {
      try {
        window.localStorage.removeItem(CONFIG.storeKey);
        window.localStorage.removeItem(CONFIG.sessionKey);
        window.sessionStorage.removeItem(CONFIG.sentKey);
      } catch (e) {}
      mem = {};
    },
    config: CONFIG
  };
})();

/* ============================================================================
 * MIGRATION
 * 1. Kill the second utm_* writer (the kx/fbp/auid snippet) or this races it.
 * 2. Strip cart attributes from Skio rebills (Skio-side) — 438 orders / £16.5k
 *    of inherited paid credit. Until then, exclude the "Subscription Recurring
 *    Order" tag from channel reporting.
 * 3. Campaign ROI = attr_age_days <= 7. The data is never deleted; the filter
 *    lives in reporting.
 * 4. Verify: load ?utm_source=test&utm_medium=email&utm_campaign=abc, check
 *    OvrAttribution.attributes(); reload with ?utm_source=facebook&utm_medium=paid
 *    and confirm utm_campaign is EMPTY, not "abc".
 * ========================================================================== */